export { default as ServerSolidIcon } from './ServerSolidIcon';
